import { render } from "./AppContactList.vue?vue&type=template&id=adb1290e"
import script from "./AppContactList.vue?vue&type=script&lang=js"
export * from "./AppContactList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\anda\\Documents\\onlinefundraising\\of_spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__